import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=5015878d&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"
import style0 from "./setting.vue?vue&type=style&index=0&id=5015878d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5015878d",
  null
  
)

export default component.exports